import { PASSWORD_MODE } from "@/features/auth/usecases/passwordMode";
import { ConsignmentVendorDetailPage } from "@/features/consignment-vendor/pages/ConsignmentVendorDetailPage";
import { createFileRoute } from "@tanstack/react-router";

type ConsignmentVendorSearch = { pw?: typeof PASSWORD_MODE.Changed };

export const Route = createFileRoute("/vendor/consignment-vendor/")({
	validateSearch: (
		search: Record<string, unknown>,
	): ConsignmentVendorSearch => ({
		pw: search.pw === PASSWORD_MODE.Changed ? PASSWORD_MODE.Changed : undefined,
	}),
	component: ConsignmentVendorRoute,
});

function ConsignmentVendorRoute() {
	const { pw } = Route.useSearch();
	return (
		<ConsignmentVendorDetailPage
			isPasswordChanged={pw === PASSWORD_MODE.Changed}
		/>
	);
}
